if ($('#sides').length) {
    (function () {
        function loaded() {
            // Refresh match height from the below function
            // $('.category-details').matchHeight();
            if ($(window).width() < 1024) {
                $(".category-description").removeAttr("style");
                $(".category-section").removeClass("categoryspecs-container");
                $(".category-section, .categoryspecs-container").css({ 'margin-bottom': '10px' });
            } else {
                $(".category-description").removeAttr("style");
                $(".category-section").addClass("categoryspecs-container");
                $(".category-section, .categoryspecs-container").css({ 'margin-bottom': '0' });
            }
            setDynamicMatchHeight();
        }
        //set dynamic height for categore details.
        //set maximum height to the description 
        function setDynamicMatchHeight() {
            if ($(window).width() > 1023) {
                var tempArray = [];
                var tempUnitCaloriesArray = [];
                $(".category-description").each(function () {
                    tempArray.push($('.category-description').height());
                });
                var setMaxHeight = Math.max.apply(Math, tempArray);
                if (setMaxHeight !== 0) {
                    $('.category-description').css({ 'height': setMaxHeight + 'px' });
                }
                var contentSection = $('.category-section').children("div").attr("style");
                if (contentSection === 'display:none') {
                    $('.category-section').closest('.category-content').find('.categoryspecs-container').css({ 'height': '1px' });
                }
            }
        }

        //If a user resizes the page from mobile to desktop, the drinks and cookies will both be shown
        var resizeTimer;

        $(window).resize(function (e) {

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                // applies generically to all items with sticky class
                mobileView();
            }, 10);
        });

        function mobileView() {
            if ($(window).width() < 1024) {
                $(".category-description").removeAttr("style");
                $(".category-section").removeClass("categoryspecs-container");
                $('.category-section, .categoryspecs-container').css({ 'height': '30px' });
                $(".category-section, .categoryspecs-container").css({ 'margin-bottom': '10px' });
            } else {
                $(".category-description").removeAttr("style");
                $(".category-section").addClass("categoryspecs-container");
                $('.category-section, .categoryspecs-container').css({ 'height': '40px' });
                $(".category-section, .categoryspecs-container").css({ 'margin-bottom': '0' });
                setDynamicMatchHeight();
            }
        }
        //call it once on page load
        (mobileView());

        $(function () {
            var action = $('#frmRestaurantMenu').attr('action');
            subwayScript.showSpinner();
            subwayScript.showSpinner1();
            ajaxGetResults(action, 'frmRestaurantMenu');
        });

        function ajaxGetResults(postUrl, formId) {
            $.ajax({
                url: postUrl,
                type: 'POST',
                data: $('#' + formId).serialize(),
                success: function (data) {
                    $('#prod-loader').hide();
                    var html = $.parseHTML(data);
                    var categoryNameInput = $(html).filter('#category-name-input');
                    subwayScript.hideSpinner();
                    $('nav > .category-title').html(categoryNameInput.val());
                    $('#sides-list').html(data);
                    var categories = [];
                    var productNames = [];
                    var prices = [];
                    var productString = [];
                    var categoryName = $('#sides-list #category-name-input').val();
                    categories.push(categoryName);
                    $('#sides-list .analytics-product-name').each(function () {
                        var txt = $(this).text();
                        var sidesProductString = categoryName.trim() + ";" + txt.trim();
                        productString.push(sidesProductString);
                        productNames.push(txt.trim());
                    });
                    analytics.pageProducts(productNames, categories, '', '');
                    // Custom select list
                    [].slice.call(document.querySelectorAll('select.cs-select')).forEach(function (el) {
                        new SelectFx(el, {
                            onChange: function (val) {
                                if(el.isMainList == 1)	{
                                    var selectedOption = $('.cs-change-detect-'+el.productId).find(':selected').data('submit-size-id');
                                    var selectedProduct = $('.cs-change-detect-'+el.productId).find(':selected').data('submit-product-id');
                                    $(".temp-cls-"+selectedProduct).find("[data-submit-product-class-id='"+selectedProduct+"']").hide();          
                                    $(".temp-cls-"+selectedProduct).find("[data-submit-product-id='"+selectedOption+"']").show(); 
                                    $('.defaul-cls').removeClass('dynamic-gray');
                                    $(".temp-cls-"+selectedProduct+" .cs-placeholder").css('color', '#008938');
                                    $(".temp-cls-"+selectedProduct).css('pointer-events', 'auto');
                                    $(".temp-cls-"+selectedProduct+' .cs-options .cs-selected').removeClass('cs-selected');	                                    
                                    $('#incrementer-'+selectedProduct).css('display','none');
                                    $('#addtobag-'+selectedProduct).prop('disabled', true);
                                    $('#categoryspecs-'+selectedProduct).css('display','none');
                                }else{
                                    el.onchange();
                                }
                                // Refresh match height for summary cards on dropdown change
                                //get the refresh height from the below function
                                setDynamicMatchHeight();
                                if ($(window).width() > 1023) {
                                    $(this).closest('.category-controls').find('.btn-incrementer').removeAttr("disabled");
                                    $('.categoryspecs-container').css({ 'height': '40px' });
                                    $(".category-section, .categoryspecs-container").css({ 'margin-bottom': '0' });
                                }
                            }
                        });
                    });

                    $('.sides-grid img').each(function () {
                        this.addEventListener('load', loaded);
                    });
                    var $addButton = $('.btn-add');
                    var submitRoute = $('#AddBagItem').attr('action');

                    var categoryName = $('#category-name-input').val();
                    analytics.appendPageName(categoryName);

                    $addButton.on('click',
                        function () {
                            var $self = $(this);
                            var productClassId = $self.data('submitProductClassId');
                            var $dropdown = $('li.cs-selected[data-submit-product-class-id=' + productClassId + ']');
                            var productId = $dropdown.data('submitProductId');

                            // if unable to locate productId based on the selected dropdown (e.g., Apple Slices) because this sides category has no options, 
                            // use product Id from the button click (productClassId).
                            if (!productId) {
                                productId = productClassId;
                            }
                            var productName = $('#title-' + productClassId).text().trim();
                            var $incrementer = $('#product-' + productClassId);
                            if (orderViewModel.currentOrder.sidesDrinksQuantity != undefined && (parseInt($incrementer.val()) + orderViewModel.currentOrder.sidesDrinksQuantity > 25)) {
                                modalShowId('#modal-sides-drinks');
                                return false;
                            }
                            $('#subway-spinner').show();
                            var idSegment = $(this).attr('id').split('-');
                            if (idSegment.length > 1) {
                                idSegment = idSegment[1];
                            }

                            var $price = $('#price-' + idSegment);
                            var price = $price.text();

                            if ($self.attr('disabled')) {
                                return false;
                            }

                            var selectedOptionItem = $dropdown.data('submitOptionId');
                            var IsSidesOrDrinks = $('#IsSidesOrDrinks').val();  
                            var cookieFlavorId = $dropdown.data('submitCookieFlavorId');

                            var model = {
                                productId: productId,
                                optionId: selectedOptionItem,
                                quantity: $incrementer.val(),
                                cartId: orderViewModel.currentOrder.cartId,
                                storeId: orderViewModel.store.id,
                                sidesOrDrinks: IsSidesOrDrinks,
                                cookieFlavorId: cookieFlavorId
                            };

                            var optionId = $dropdown.data('submitOptionid');
                            var optionVal = $dropdown.data('submitOptionValue');

                            if (optionId && optionVal) {
                                model.options = [
                                    {
                                        id: optionId,
                                        val: optionVal
                                    }
                                ]
                            }
                            
                            $.ajax({
                                url: submitRoute,
                                type: 'POST',
                                data: model,
                                success: function (response) {
                                    analytics.addItemToBag($('#category-name-input').val(), productName, price, model.quantity, "productdetails");
                                    orderViewModel.currentOrder.cartId = response.CartId;
                                    orderViewModel.currentOrder.cartQuantity = response.CartQuantity;
                                    var categoryId = $('#categoryId').val();
                                    orderViewModel.addCartProducts('', productId, categoryId, '');
                                    orderViewModel.save();
                                    var itemsInCart = orderViewModel.currentOrder.cartQuantity;
                                    var $bagBadge = $('.badge-bagcount');
                                    compNavLocation.updateCartBag();
                                    if (!itemsInCart || !$bagBadge.length) {
                                        $bagBadge.hide();
                                    } else {
                                        $bagBadge.text(itemsInCart);
                                        $bagBadge.show();
                                    }
                                    modalShowId('#AddMoreDrinksToBag');
                                    $('#add-to-cart').click(function () {
                                        var buttonText = $(this).text();
                                        analytics.addSomethingElse(buttonText);
                                        window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
                                        modalClose(true);
                                    });

                                    $('#btn-to-checkout').click(function () {
                                        var buttonText = $(this).text();
                                        analytics.goToCheckout(buttonText);
                                        window.location.replace(response.SuccessUrl);
                                        modalClose(true);
                                    });

                                },
                                error: function (jqXhr) {
                                    subwayScript.showAjaxError(jqXhr);
                                    $('#subway-spinner').hide();
                                }
                            });
                            return true;
                        });
                    subwayScript.hideSpinner1()
                },
                error: function (jqXhr) {
                    subwayScript.hideSpinner();
                    subwayScript.hideSpinner1()
                    subwayScript.showAjaxError(jqXhr);
                }
            });
        }

        $(function () {
            var $categories = $('.product-grid');
            var $category = $('li', $categories);
            var $categorylink = $('a', $category);

            // set active selected on focus
            $('li')
                .focusin(function () {
                    $(this).addClass('active');
                });
            $('li')
                .focusout(function () {
                    $(this).removeClass('active');
                });

            // map keys
            var keyCode = {
                13: 'enter',
                27: 'escape',
                38: 'up',
                40: 'bottom',
                37: 'left',
                39: 'right'
            };

            // listen for keyup
                window.addEventListener('keyup',
                function (e) {
                    if (e.origin !== window.location.origin){
                        return;
                    }
                    // get key pressed
                    var key = keyCode[e.which];

                    // get  active categories
                    var $active = $('.active');

                    if (key === 'enter') {
                        // deselect if already selected
                        if ($active.hasClass('selected')) {
                            $active.removeClass('selected');
                        } else {
                            $active.addClass('selected');
                        }
                    }

                    if (key === 'right') {
                        $category.removeClass('active').attr('aria-selected', 'false');

                        if ($active.length === 0) {
                            $categorylink.first().focus().attr('aria-selected', 'true');
                        } else if ($active.next().length === 0) {
                            $active.siblings().first().addClass('active').attr('aria-selected', 'true');
                            $('.active a').focus();
                        } else {
                            $active.next().addClass('active').attr('aria-selected', 'true');
                            $('.active a').focus();
                        }
                    }

                    if (key === 'left') {
                        $category.removeClass('active').attr('aria-selected', 'false');

                        if ($active.prev().length === 0) {
                            $active.siblings().last().addClass('active').attr('aria-selected', 'true');
                            $('.active a').focus();
                        } else {
                            $active.prev().addClass('active').attr('aria-selected', 'true');
                            $('.active a').focus();
                        }
                    }
                },
                false);            
        });
    })();
}